import React from 'react';
import { TruckIcon } from 'lucide-react';
export function FreightPanel() {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-72">
      <div className="flex justify-between items-center" data-id="element-73">
        <h3 className="text-lg font-medium text-gray-800" data-id="element-74">Fragt</h3>
        <TruckIcon size={20} className="text-gray-400" data-id="element-75" />
      </div>
      <div className="mt-6 grid grid-cols-2 gap-6" data-id="element-76">
        <div className="bg-gray-50 rounded-xl p-4" data-id="element-77">
          <p className="text-sm text-gray-500" data-id="element-78">Fragt (cost)</p>
          <p className="text-xl font-bold text-gray-800 mt-1" data-id="element-79">4.800 kr</p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-80">Zone: DK-Z3</p>
        </div>
        <div className="bg-gray-50 rounded-xl p-4" data-id="element-81">
          <p className="text-sm text-gray-500" data-id="element-82">Fragt (faktureret)</p>
          <p className="text-xl font-bold text-gray-800 mt-1" data-id="element-83">5.500 kr</p>
          <div className="flex items-center mt-1" data-id="element-84">
            <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full" data-id="element-85">
              Fragt DB: 700 kr
            </span>
          </div>
        </div>
      </div>
    </div>;
}